import angular from 'angular';
import template from './djelatnik.html';
import {DjelatnikController} from './djelatnik.controller.js';

const DjelatnikComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: DjelatnikController,
    controllerAs: 'vm'
};

export {DjelatnikComponent};



// WEBPACK FOOTER //
// ./app/components/djelatnik/djelatnik.component.js